<template>
  <v-btn
    rounded
    elevation="0"
    :width="40"
    :height="40"
    color="white"
    class="switch-button pa-4"
    v-on="$listeners"
  >
    <c360-icon v-if="activated" icon="Close_SM" />
    <svg
      v-else
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 6C4 7.10457 4.89543 8 6 8V8C7.10457 8 8 7.10457 8 6V6C8 4.89543 7.10457 4 6 4V4C4.89543 4 4 4.89543 4 6V6ZM10 18C10 19.1046 10.8954 20 12 20V20C13.1046 20 14 19.1046 14 18V18C14 16.8954 13.1046 16 12 16V16C10.8954 16 10 16.8954 10 18V18ZM8 18C8 19.1046 7.10457 20 6 20V20C4.89543 20 4 19.1046 4 18V18C4 16.8954 4.89543 16 6 16V16C7.10457 16 8 16.8954 8 18V18ZM4 12C4 13.1046 4.89543 14 6 14V14C7.10457 14 8 13.1046 8 12V12C8 10.8954 7.10457 10 6 10V10C4.89543 10 4 10.8954 4 12V12ZM14 12C14 13.1046 13.1046 14 12 14V14C10.8954 14 10 13.1046 10 12V12C10 10.8954 10.8954 10 12 10V10C13.1046 10 14 10.8954 14 12V12ZM18 4C16.8954 4 16 4.89543 16 6V6C16 7.10457 16.8954 8 18 8V8C19.1046 8 20 7.10457 20 6V6C20 4.89543 19.1046 4 18 4V4ZM14 6C14 7.10457 13.1046 8 12 8V8C10.8954 8 10 7.10457 10 6V6C10 4.89543 10.8954 4 12 4V4C13.1046 4 14 4.89543 14 6V6ZM16 12C16 13.1046 16.8954 14 18 14V14C19.1046 14 20 13.1046 20 12V12C20 10.8954 19.1046 10 18 10V10C16.8954 10 16 10.8954 16 12V12ZM20 18C20 19.1046 19.1046 20 18 20V20C16.8954 20 16 19.1046 16 18V18C16 16.8954 16.8954 16 18 16V16C19.1046 16 20 16.8954 20 18V18Z"
        fill="url(#switch_button_gradient)"
      />
      <defs>
        <linearGradient
          id="switch_button_gradient"
          x1="4"
          y1="12"
          x2="20"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop :stop-color="gradient.start" />
          <stop offset="1" :stop-color="gradient.end" />
        </linearGradient>
      </defs>
    </svg>
  </v-btn>
</template>

<script>
  import Vue from 'vue';
  import { C360Icon } from '../../Icon';
  import { getGradient } from '../model';

  export default Vue.extend({
    name: 'C360Switch',

    components: { C360Icon },

    props: {
      /**
       * Switch button is activated.
       */
      activated: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      gradient() {
        return getGradient();
      },
    },
  });
</script>

<style scoped>
  .switch-button.v-btn {
    min-width: 0 !important;
  }
</style>
